import { cn } from "@/lib/utils";

/**
 * Ambient background for the auth screens and hero panels: two slow-drifting
 * auras behind a static star layer. CSS only — no canvas, no rAF, and the
 * reduced-motion rule in index.css freezes the drift.
 */
export function Starfield({ className }: { className?: string }) {
  return (
    <div aria-hidden className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}>
      <div
        className="absolute inset-0 opacity-100"
        style={{
          backgroundImage: `
            radial-gradient(1.2px 1.2px at 18% 22%, rgb(255 255 255 / 0.55), transparent 60%),
            radial-gradient(1px 1px at 62% 14%, rgb(255 255 255 / 0.4), transparent 60%),
            radial-gradient(1.4px 1.4px at 82% 38%, rgb(255 255 255 / 0.5), transparent 60%),
            radial-gradient(1px 1px at 34% 62%, rgb(255 255 255 / 0.35), transparent 60%),
            radial-gradient(1.6px 1.6px at 71% 74%, rgb(255 255 255 / 0.45), transparent 60%),
            radial-gradient(1px 1px at 12% 84%, rgb(255 255 255 / 0.3), transparent 60%),
            radial-gradient(1.1px 1.1px at 48% 40%, rgb(255 255 255 / 0.3), transparent 60%),
            radial-gradient(1px 1px at 92% 66%, rgb(255 255 255 / 0.3), transparent 60%)
          `,
        }}
      />
      <div
        className="orbit-aura -top-40 -left-32 size-[34rem]"
        style={{ background: "var(--brand-glow)" }}
      />
      <div
        className="orbit-aura -right-40 -bottom-52 size-[38rem] [animation-delay:-8s]"
        style={{ background: "color-mix(in oklab, var(--chart-7) 22%, transparent)" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background" />
    </div>
  );
}
